import { OntarioPurchaseCost } from '../purchase-cost'

export const PurchaseCost = {
  ...OntarioPurchaseCost,
} as const
